var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.urlReceiveFlag)?_c('embed',{class:_vm.classes,style:(_vm.styles),attrs:{"src":_vm.signedUrl,"type":"application/pdf"}}):_c('embed',{class:_vm.classes,style:(_vm.styles),attrs:{"type":"application/pdf","src":_vm.newSrcImage}})])}
var staticRenderFns = []

export { render, staticRenderFns }